import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const businessOverview = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: CROSS_API_URL }),
    reducerPath: 'api.businessOverview',
    tagTypes: ['businessOverview'],
    endpoints: (builder) => ({
        getPlatformsCustom: builder.query<any, { startDate: string | null, endDate: string | null, countries: string[], keywords: string[], devices: string[], workspaceId: any }>({
            query: ({ startDate, endDate, countries, keywords, devices, workspaceId }) => {
                const url = `/businessOverview/getPlatformsCustom`;
                const body = {
                    startDate,
                    endDate,
                    keywords,
                    countries,
                    devices,
                    workspaceId
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        getStats: builder.query<any, { workspaceId: any, platforms: any, devices: any, countries: any, start_date: any, end_date: any, sinceActivate: any, compare_start_date: any, compare_end_date: any, compare: any, savingsFormula: any, timestep: any }>({
            query: ({ workspaceId, platforms, devices, countries, start_date, end_date, compare_start_date, compare_end_date, compare, sinceActivate, savingsFormula, timestep }) => {
                const url = `/businessOverview/getStats`;
                const body = {
                    workspaceId,
                    platforms,
                    devices,
                    countries,
                    start_date,
                    end_date,
                    compare_start_date,
                    compare_end_date,
                    compare,
                    savingsFormula,
                    timestep,
                    sinceActivate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        getPerformanceGraph: builder.query<any, {
            workspaceId: any,
            platforms: string[] | null,
            devices: string[] | null,
            countries: string[] | null,
            start_date: any,
            end_date: any,
            savingsFormula?: string,
            compare_start_date: any,
            timestep?: string,
            sinceActivate: any
        }>({
            query: ({ workspaceId, platforms, devices, countries, start_date, end_date, savingsFormula, timestep, sinceActivate, compare_start_date }) => {
                const url = `/businessOverview/getPerformanceGraph`;
                const body = {
                    workspaceId,
                    platforms,
                    devices,
                    countries,
                    compare_start_date,
                    start_date,
                    end_date,
                    savingsFormula,
                    timestep,
                    sinceActivate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),

        getPerformanceSplit: builder.query<any, {
            workspaceId: any,
            platforms: string[] | null,
            devices: string[] | null,
            countries: string[] | null,
            start_date: string | null,
            end_date: string | null,
            compare_start_date: string | null,
            compare_end_date: string | null,
            savingsFormula?: string,
            timestep?: string,
            split: 'country' | 'platform' | 'date' | 'device',
            compare: any,
            bqTable: any,
            sinceActivate?: any
        }>({
            query: ({ workspaceId, sinceActivate, platforms, devices, countries, bqTable, start_date, end_date, compare_start_date, compare_end_date, savingsFormula, timestep, split, compare }) => {
                const url = `/businessOverview/getPerformanceSplit`;
                const body = {
                    workspaceId,
                    platforms,
                    devices,
                    countries,
                    start_date,
                    end_date,
                    compare_start_date,
                    compare_end_date,
                    savingsFormula,
                    timestep,
                    split,
                    compare,
                    bqTable,
                    sinceActivate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        getFilters: builder.query<any, {
            workspaceId: any,
            start_date: string | null,
            end_date: string | null,
            countries: string[],
            devices: string[],
            platforms: string[]
        }>({
            query: ({ workspaceId, start_date, end_date, countries, devices, platforms }) => {
                const url = `/businessOverview/getFilters`;
                const body = {
                    workspaceId,
                    start_date,
                    end_date,
                    countries,
                    devices,
                    platforms,
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
    }),
});

export const {
    useGetPlatformsCustomQuery,
    useGetStatsQuery,
    useGetPerformanceGraphQuery,
    useGetPerformanceSplitQuery,
    useGetFiltersQuery
} = businessOverview;

export default businessOverview;
